import { intercept, toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Prompt, withRouter } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import DataTable from 'src/Components/DataTable';
import { EButton } from 'src/Components/EInput';
import WellFooter from 'src/Components/Footer/WellFooter';
import { SyncStore } from 'src/Stores/Sync/SyncStore';
import { WellsStore } from 'src/Stores/Wells/WellsStore';
import { IWell } from '../../../../Interfaces/WellInterface';
import ButtonRow from '../../../ButtonRow';
import WorkflowHeader from '../../WorkflowHeader';
import WellCloseButton from '../WellCloseButton';
import WellRevertCloseButton from "../WellRevertCloseButton";
import Contacts from './ContactList';
import WellContactsCopyModal from './WellContactsCopyModal';


interface IParams {
    wellId: string;
}

@inject('stores')
@observer
class WellContacts extends React.Component {
    public props: any;
    public params: IParams;
    private WellsStore: WellsStore;
    private SyncStore: SyncStore;
    // disposers
    public wellDisposer: any;

    public state = {
        addEngineerModal: false,
        contactsCopyModal: false,
        isDirty: false,
        well: new IWell(),
        wellId: this.props.match.params.wellId,
        wellPageTitle: 'New Well',
    };

    constructor(props: any) {
        super(props);

        this.WellsStore = this.props.stores.WellsStore;
        this.SyncStore = props.stores.SyncStore;
        this.params = this.props.match.params;

        this.updateWellModel = this.updateWellModel.bind(this);

        this.handleChange = this.handleChange.bind(this);
    }

    public componentDidMount() {
        this.createDisposers();
        if (this.props.stores.WellsStore.well) {
            this.setState({
                well: this.props.stores.WellsStore.well,
            });
        } else {
            this.WellsStore.getWellDetails(this.params.wellId);
        }
    }

    public componentWillUnmount() {
        this.wellDisposer();
    }

    public createDisposers() {
        this.wellDisposer = intercept(this.WellsStore, 'well', (change: any) => {
            this.setState({
                well: toJS(change.newValue),
            });

            return change;
        });
    }

    private updateWellModel() {
        this.WellsStore.updateWellModel(this.state.well)
            .then(
                (data: any) => {
                    if(data) {
                        this.setState({
                            isDirty: false,
                        });
                    }
                }
            );
    }

    public handleChange(well: IWell) {
        this.setState({
            isDirty: true,
            well
        });
    }

    private formatGroupEmails = () => {
        const operator = this.state.well.operator;
        const contractor = this.state.well.contractor;
        const headers = [
            "Email",
            "Type",
            "Description",
        ];
        const rows = [] as any[];
        operator.groupEmails.forEach(ge => {
            const tempRow = [
                {
                    content: ge.email
                },
                {
                    content: "Operator"
                },
                {
                    content: ge.description,
                }
            ];

            rows.push(tempRow);
        });

        contractor.groupEmails.forEach(ge => {
            const tempRow = [
                {
                    content: ge.email
                },
                {
                    content: "Contractor"
                },
                {
                    content: ge.description
                }
            ];

            rows.push(tempRow);
        });



        return { headers, rows };
    }

    private formatInternalGroupEmails = () => {
        const internal = this.state.well.internalEmails;
        const rows = [] as any[];
        const headers = [
            "Email",
            "Type",
            "Description",
        ];
        internal.forEach(ge => {
            const tempRow = [
                {
                    content: ge.email
                },
                {
                    content: "Internal"
                },
                {
                    content: ge.description
                }
            ];

            rows.push(tempRow);
        });

        return { headers, rows };
    }

    private buttonNavigation = (event: any) => {
        const $target = event.target;
        
        if ( $target.name === 'previousButton' ) {
            this.props.history.push('/well/' + this.params.wellId + '/location');
        } else {
            if (this.props.workflowHeaderItems[0].some((w: string) => w === 'Dispatches')) {
                this.props.history.push('/well/' + this.params.wellId + '/dispatches');
            } else {
                this.props.history.push('/well/' + this.params.wellId + '/review');
            }
        }
    }

    public toggleCopyModal = () => {
        this.setState({
            contactsCopyModal: !this.state.contactsCopyModal
        });
    }

    public render() {
        return(
            <div>
                <Prompt when={this.state.isDirty} message={"Changes have been made.\n\nPress Cancel then Press Save OR Press OK to continue without saving."} />
                <WorkflowHeader wellSetupComplete={this.state.well.wellSetupComplete} workflowHeaderItems={this.props.workflowHeaderItems}/>
                <Row>
                    <Col md="12">
                        <h3>Internal Distribution Emails</h3>
                        <DataTable
                            list={this.formatInternalGroupEmails()}
                        />
                    </Col>
                    <Col md="12">
                        <h3>External Distribution Emails</h3>
                        <DataTable
                            list={this.formatGroupEmails()}
                        />
                    </Col>
                    {
                    !this.SyncStore.offline &&
                        <Col>
                            <Button color="primary" onClick={this.toggleCopyModal}>Copy Contacts From Another Well</Button>
                        </Col>
                    }
                    <Col md="12">
                        <Contacts type="operator" wellId={this.state.wellId} well={this.state.well} handleChange={this.handleChange} />
                    </Col>
                    <Col md="12">
                        <Contacts type='contractor' wellId={this.state.wellId} well={this.state.well} handleChange={this.handleChange}/>
                    </Col>
                    <Col md="12">
                        <Contacts type='other' wellId={this.state.wellId} well={this.state.well} handleChange={this.handleChange}/>
                    </Col>
                </Row>
                <ButtonRow>
                    <WellRevertCloseButton />
                { <WellCloseButton />}
                    <Button className="secondary" name="previousButton" onClick={this.buttonNavigation}>Previous</Button>
                    { this.WellsStore.canUpdateWell() && <EButton color="primary" name="save" onClick={this.updateWellModel}>Save</EButton>}
                    <Button className="secondary" name="nextButton" onClick={this.buttonNavigation}>Next</Button>
                    <WellFooter />
                </ButtonRow>
                {
                    !this.SyncStore.offline &&
                    <WellContactsCopyModal handleChange={this.handleChange} open={this.state.contactsCopyModal} toggle={this.toggleCopyModal} />
                }
            </div>
        );
    }
}

export default withRouter(WellContacts);



// WEBPACK FOOTER //
// ./src/Components/Main/WellWorkflow/WellContacts/WellContacts.tsx